import {Component, Input} from '@angular/core';
import {Subject} from "rxjs";
import {BsModalRef} from "ngx-bootstrap/modal";
import {GritUserService} from "../../../services/grit/grit.user.service";
import {NOTAM} from "../../../models/grit/grit.notam";
import {DeviceSectorizationType} from "../../../models/grit/grit.device-model";
import {GritInterferenceTestService} from "../../../services/grit/grit.interference-test.service";
import {UiBlockService} from "../../../services/ui-block.service";
import {GritApiService} from "../../../services/grit/grit.api.service";
import {ModalControlService} from "../../../services/modal-control.service";

@Component({
  selector: 'app-send-notam',
  templateUrl: './send-notam.component.html',
  styleUrls: ['./send-notam.component.scss', '../../../app.component.scss'],
  standalone: false
})
export class SendNotamComponent {
  @Input({required: true}) protected notam : NOTAM = null;

  protected list : string = null;

  constructor(private bsModalRef : BsModalRef,
              protected gritUserService : GritUserService,
              protected interferenceTestService : GritInterferenceTestService,
              private uiBlock: UiBlockService,
              protected modalService: ModalControlService,
              private gritAPIService: GritApiService,
  ) {}


  ok(){
    this.bsModalRef.hide();

    this.bsModalRef.onHidden.subscribe(() =>{
      this.uiBlock.startBlock("Sending Notam...")

      let interferenceTest = this.interferenceTestService.projectInterferenceTest;
      let emails = this.gritUserService.profile.mailingList.find(list => list.name == this.list)?.list.map(entry => entry.email) ?? null;

      if (!emails || emails.length == 0) {
        this.uiBlock.stopBlock();

        return;
      }

      return this.gritAPIService.interferenceTestSendNOTAM(interferenceTest.id, emails, this.notam.generate()).then(
        (success) => {this.modalService.showMesssageModal('NOATM Sent', "NOTAM was sent.");},
        (error) => {this.modalService.showMesssageModal('NOATM Failed', "NOTAM wasn't sent.");},
      ).finally(() => this.uiBlock.stopBlock())
    })
  }

  cancel(){
    this.bsModalRef.hide();
  }
}
